import axios from 'axios';
import router from '../router';

let state = {
    // Rope guard
    customerIdKidSelection: [],
    positionMotorSelection: [],
    ropePullSelection: [],
    adjustabilitySelection: [],
    thirdRopeGuardSelection: [],
    tnruev: undefined,
    deliverRopeSelection: [],
    tractionSheaveCoverSelection: {},
    ropeClampSelection: {},
    rescueReturnDeviceSelection: {},
    ropeGuardDetailsSelected: {},
    deliverRopeDisabled: false,

    showRopeGuardDetails: false,

    ropeGuardArgument: undefined,
    altRopeGuardSelection: null,
    altRopeGuard: null,
    altLseilsSelection: [],
    altLtsabdSelection: [],
    altLtklemSelection: [],
    altLruevSelection: [],
    altLseilsSelectedCode: null,
    altLtsabdSelectedCode: null,
    altLtklemSelectedCode: null,
    altLruevSelectedCode: null,
}

const actions = {
    set_ropeGuardManual_storeAction({ rootState, commit, dispatch }) {
        dispatch('change_ropeGuardArgument_storeAction');
        if (rootState.psgModal.psgMenu == false || (rootState.psgModal.motorDataSch != null && rootState.psgModal.motorDataSch.mbg != null)) {
            dispatch('get_customerIdKidSelection_storeAction');
        }
    },
    change_ropeGuardArgument_storeAction({ rootState, commit, dispatch, getters, rootGetters }) {
        var kidsch = null;

        var motorType = null;
        var motorSize = null;
        var motorPackage = null;
        var motorZusatz = null;
        var temperatureMonitoring = null;
        var sM250_TS280 = null;

        if (rootState.psgModal.psgMenu == false) {
            motorType = rootState.inputsManual.motorType;
            motorSize = rootState.inputsManual.motorSize;
            motorPackage = rootState.inputsManual.motorPackage;
            motorZusatz = rootState.inputsManual.motorZusatz;
            temperatureMonitoring = rootState.inputsManual.temperatureMonitoring;
            sM250_TS280 = state.sM250_TS280;
            if (getters.selectedCustomerIdKid != null && getters.selectedCustomerIdKid.hasOwnProperty('text')) { kidsch = getters.selectedCustomerIdKid.text.text; }

            if (rootGetters['inputsManual/hasMotorManualData']) {
                kidsch = rootState.inputsManual.motorManualData.details.kidsch;
                motorType = rootState.inputsManual.motorManualData.details.mtyp;
                motorSize = rootState.inputsManual.motorManualData.details.mbg;
                motorPackage = rootState.inputsManual.motorManualData.details.mfe;
                motorZusatz = rootState.inputsManual.motorManualData.details.mzus;
                temperatureMonitoring = rootState.inputsManual.motorManualData.details.msart;
                sM250_TS280 = rootState.inputsManual.motorManualData.details.sM250_TS280;
            }
        }
        else {
            if (rootState.psgModal.motorDataSch != null && rootState.psgModal.motorDataSch.mbg != null) {
                motorType = rootState.psgModal.motorDataSch.mtyp;
                motorSize = rootState.psgModal.motorDataSch.mbg;
                motorPackage = rootState.psgModal.motorDataSch.mfe;
                motorZusatz = rootState.psgModal.motorDataSch.mzus;
                temperatureMonitoring = rootState.psgModal.motorDataSch.msart;
                sM250_TS280 = rootState.psgModal.motorDataSch.sM250_TS280;
            }
        }
        if (motorSize != null) {
            const value = {
                motorType: motorType,
                motorSize: motorSize,
                motorPackage: motorPackage,
                motorZusatz: motorZusatz,
                temperatureMonitoring: temperatureMonitoring,
                kid: rootState.manualHome.kid,
                kidsch: kidsch,
                sM250_TS280: sM250_TS280,
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
                tractionSheaveDiameter: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/tractionSheavedetailsSelectionZLW'].tD : rootGetters['inputsManual/tractionSheavedetailsSelection'].tD,
                tractionSheaveWidth: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/tractionSheavedetailsSelectionZLW'].tB : rootGetters['inputsManual/tractionSheavedetailsSelection'].tB,
            }

            commit('change_ropeGuardArgument_storeMutation', value);
        }
        else {
            commit('change_ropeGuardArgument_storeMutation', null);
        }
    },

    // rope guard
    async get_customerIdKidSelection_storeAction({ rootState, commit, dispatch, getters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        if (state.ropeGuardArgument != null && state.ropeGuardArgument.tractionSheaveDiameter != null && state.ropeGuardArgument.tractionSheaveWidth != null) {
            const data = {
                motorType: state.ropeGuardArgument.motorType,
                motorSize: state.ropeGuardArgument.motorSize,
                motorPackage: state.ropeGuardArgument.motorPackage,
                motorZusatz: state.ropeGuardArgument.motorZusatz,
                temperatureMonitoring: state.ropeGuardArgument.temperatureMonitoring,
                kid: rootState.manualHome.kid,
                tractionSheaveDiameter: state.ropeGuardArgument.tractionSheaveDiameter,
                tractionSheaveWidth: state.ropeGuardArgument.tractionSheaveWidth,
                sM250_TS280: state.ropeGuardArgument.sM250_TS280,
                configurationOverviewsManualId: state.ropeGuardArgument.configurationOverviewsManualId,
                kidsch: state.ropeGuardArgument.kidsch,
            }

            await axios({
                method: 'post',
                url: '/api/inputsManual/get_customerIdKidSelection',
                data: {
                    data: data,
                },
            })
                .then((response) => {
                    commit('change_customerIdKidSelection_storeMutation', response.data);
                    var selectedCustomerIdKid = state.customerIdKidSelection.find(i => (i.selected == true));
                    if (selectedCustomerIdKid == null && state.customerIdKidSelection.length > 0) {
                        selectedCustomerIdKid = state.customerIdKidSelection[0];
                    }

                    if (selectedCustomerIdKid != null) {
                        dispatch('change_customerIdKid_storeAction', selectedCustomerIdKid);
                    }
                })
                .catch(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                })
                .then(() => {
                })
        }
    },
    async get_positionMotorSelection_storeAction({ rootState, commit, dispatch, getters, rootGetters }, value) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            motorType: state.ropeGuardArgument.motorType,
            motorSize: state.ropeGuardArgument.motorSize,
            motorPackage: state.ropeGuardArgument.motorPackage,
            motorZusatz: state.ropeGuardArgument.motorZusatz,
            temperatureMonitoring: state.ropeGuardArgument.temperatureMonitoring,
            kidsch: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].kidsch : getters.customerIdKid,
            tractionSheaveDiameter: state.ropeGuardArgument.tractionSheaveDiameter,
            tractionSheaveWidth: state.ropeGuardArgument.tractionSheaveWidth,
            sM250_TS280: state.ropeGuardArgument.sM250_TS280,
            deliverRope: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].lseils : getters.deliverRope,
            deliverCover: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].ltsabd : getters.tractionSheaveCover,
            configurationOverviewsManualId: state.ropeGuardArgument.configurationOverviewsManualId,
            motorPosition: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].fuesse : getters.positionMotor,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_positionMotorSelection',
            data: {
                data: data,
            },
        })
            .then((response) => {
                commit('change_positionMotorSelection_storeMutation', response.data);
                var hasDeliverSelection = (getters.selectedDeliverRope != null && getters.selectedDeliverRope.text.code != 0)
                    || (getters.selectedTractionSheaveCover != null && getters.selectedTractionSheaveCover.text.code != 0);
                var hasCurrentPositionMotor = getters.selectedPositionMotor != null && getters.selectedPositionMotor.hasOwnProperty('text');
                var firstIndex_whichMeetConditions = -1;
                if (hasDeliverSelection && state.positionMotorSelection.length > 0 && hasCurrentPositionMotor) {
                    firstIndex_whichMeetConditions = state.positionMotorSelection.findIndex(i => (i.text.text == getters.selectedPositionMotor.text.text));
                }

                if (firstIndex_whichMeetConditions < 0) {
                    firstIndex_whichMeetConditions = state.positionMotorSelection.findIndex(i => (i.selected == true));
                }

                if (firstIndex_whichMeetConditions < 0 && state.positionMotorSelection.length > 0) {
                    firstIndex_whichMeetConditions = 0;
                }

                dispatch('change_positionMotor_storeAction', firstIndex_whichMeetConditions > -1
                    ? state.positionMotorSelection[firstIndex_whichMeetConditions]
                    : null);
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_ropePullSelection_storeAction({ rootState, commit, dispatch, getters, rootGetters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            motorType: state.ropeGuardArgument.motorType,
            motorSize: state.ropeGuardArgument.motorSize,
            motorPackage: state.ropeGuardArgument.motorPackage,
            motorZusatz: state.ropeGuardArgument.motorZusatz,
            temperatureMonitoring: state.ropeGuardArgument.temperatureMonitoring,
            kidsch: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].kidsch : getters.customerIdKid,
            tractionSheaveDiameter: state.ropeGuardArgument.tractionSheaveDiameter,
            tractionSheaveWidth: state.ropeGuardArgument.tractionSheaveWidth,
            sM250_TS280: state.ropeGuardArgument.sM250_TS280,
            motorPosition: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].fuesse : getters.positionMotor,
            deliverRope: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].lseils : getters.deliverRope,
            deliverCover: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].ltsabd : getters.tractionSheaveCover,
            configurationOverviewsManualId: state.ropeGuardArgument.configurationOverviewsManualId,
            ropePull: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].seilab : getters.ropePull,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_ropePullSelection',
            data: {
                data: data,
            },
        })
            .then((response) => {
                commit('change_ropePullSelection_storeMutation', response.data);
                var hasDeliverSelection = (getters.selectedDeliverRope != null && getters.selectedDeliverRope.text.code != 0)
                    || (getters.selectedTractionSheaveCover != null && getters.selectedTractionSheaveCover.text.code != 0);
                var hasCurrentRopePull = getters.selectedRopePull != null && getters.selectedRopePull.hasOwnProperty('text');
                var firstIndex_whichMeetConditions = -1

                if (hasDeliverSelection && state.ropePullSelection.length > 0 && hasCurrentRopePull) {
                    firstIndex_whichMeetConditions = state.ropePullSelection.findIndex(i => (i.text.text == getters.selectedRopePull.text.text));
                }

                if (firstIndex_whichMeetConditions < 0) {
                    firstIndex_whichMeetConditions = state.ropePullSelection.findIndex(i => (i.selected == true));
                }

                if (firstIndex_whichMeetConditions < 0 && state.ropePullSelection.length > 0) {
                    firstIndex_whichMeetConditions = 0;
                }

                dispatch('change_ropePull_storeAction', firstIndex_whichMeetConditions > -1
                    ? state.ropePullSelection[firstIndex_whichMeetConditions]
                    : null);
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_adjustabilitySelection_storeAction({ rootState, commit, dispatch, getters, rootGetters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        const motorPosition = state.ropeGuardDetailsSelected != null && state.ropeGuardDetailsSelected.hasOwnProperty('motorPosition') 
            ? state.ropeGuardDetailsSelected.motorPosition.text
            : rootGetters['inputsManual/hasMotorManualData'] == true 
            ? rootGetters['inputsManual/ropeGuardSelectionZLW'].fuesse 
            : getters.positionMotor;

        const ropePull = state.ropeGuardDetailsSelected != null && state.ropeGuardDetailsSelected.hasOwnProperty('ropePull') 
            ? state.ropeGuardDetailsSelected.ropePull.text
            : rootGetters['inputsManual/hasMotorManualData'] == true 
            ? rootGetters['inputsManual/ropeGuardSelectionZLW'].seilab 
            : getters.ropePull;

        const usw = state.ropeGuardDetailsSelected != null && state.ropeGuardDetailsSelected.hasOwnProperty('usw')
            ? state.ropeGuardDetailsSelected.usw
            : null;

        const data = {
            motorType: state.ropeGuardArgument.motorType,
            motorSize: state.ropeGuardArgument.motorSize,
            motorPackage: state.ropeGuardArgument.motorPackage,
            motorZusatz: state.ropeGuardArgument.motorZusatz,
            temperatureMonitoring: state.ropeGuardArgument.temperatureMonitoring,
            kidsch: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].kidsch : getters.customerIdKid,
            tractionSheaveDiameter: state.ropeGuardArgument.tractionSheaveDiameter,
            tractionSheaveWidth: state.ropeGuardArgument.tractionSheaveWidth,
            sM250_TS280: state.ropeGuardArgument.sM250_TS280,
            motorPosition: motorPosition,
            ropePull: ropePull,
            deliverRope: (getters.deliverRope === null || getters.deliverRope === '') && rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].lseils : getters.deliverRope,
            deliverCover: (getters.tractionSheaveCover === null || getters.tractionSheaveCover === '') && rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].ltsabd : getters.tractionSheaveCover,
            configurationOverviewsManualId: state.ropeGuardArgument.configurationOverviewsManualId,
            adjustability: (getters.adjustability === null || getters.adjustability === '') && rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].einst : getters.adjustability,
            psgProdAp: (state.motorSchModData != null) ? state.motorSchModData.psG_ProdAP : null,
            psgMotorID: (state.motorSchModData != null) ? state.motorSchModData.psG_MotorID : null,
            usw: usw,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_adjustabilitySelection',
            data: {
                data: data,
            },
        })
            .then((response) => {
                commit('change_adjustabilitySelection_storeMutation', response.data);

                var hasDeliverSelection = (getters.selectedDeliverRope != null && getters.selectedDeliverRope.text.code != 0)
                    || (getters.selectedTractionSheaveCover != null && getters.selectedTractionSheaveCover.text.code != 0);
                var hasCurrentAdjustability = getters.selectedAdjustability != null && getters.selectedAdjustability.hasOwnProperty('text');
                var firstIndex_whichMeetConditions = -1

                if (hasDeliverSelection && state.adjustabilitySelection.length > 0 && hasCurrentAdjustability) {
                    firstIndex_whichMeetConditions = state.adjustabilitySelection.findIndex(i => (i.text.text == getters.selectedAdjustability.text.text));
                }

                if (firstIndex_whichMeetConditions < 0) {
                    firstIndex_whichMeetConditions = state.adjustabilitySelection.findIndex(i => (i.selected == true));
                }

                if (firstIndex_whichMeetConditions < 0 && state.adjustabilitySelection.length > 0) {
                    firstIndex_whichMeetConditions = 0;
                }
                dispatch('change_adjustability_storeAction', firstIndex_whichMeetConditions > -1
                    ? state.adjustabilitySelection[firstIndex_whichMeetConditions]
                    : null);
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_thirdRopeGuard_storeAction({ rootState, commit, dispatch, getters, rootGetters }) {
        const motorPosition = state.ropeGuardDetailsSelected != null && state.ropeGuardDetailsSelected.hasOwnProperty('motorPosition') 
            ? state.ropeGuardDetailsSelected.motorPosition.text
            : rootGetters['inputsManual/hasMotorManualData'] == true 
            ? rootGetters['inputsManual/ropeGuardSelectionZLW'].fuesse 
            : getters.positionMotor;

        const ropePull = state.ropeGuardDetailsSelected != null && state.ropeGuardDetailsSelected.hasOwnProperty('ropePull') 
            ? state.ropeGuardDetailsSelected.ropePull.text
            : rootGetters['inputsManual/hasMotorManualData'] == true 
            ? rootGetters['inputsManual/ropeGuardSelectionZLW'].seilab 
            : getters.ropePull;

        const data = {
            motorType: state.ropeGuardArgument.motorType,
            motorSize: state.ropeGuardArgument.motorSize,
            motorPackage: state.ropeGuardArgument.motorPackage,
            motorZusatz: state.ropeGuardArgument.motorZusatz,
            temperatureMonitoring: state.ropeGuardArgument.temperatureMonitoring,
            kidsch: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].kidsch : getters.customerIdKid,
            tractionSheaveDiameter: state.ropeGuardArgument.tractionSheaveDiameter,
            tractionSheaveWidth: state.ropeGuardArgument.tractionSheaveWidth,
            sM250_TS280: state.ropeGuardArgument.sM250_TS280,
            motorPosition: motorPosition,
            ropePull: ropePull,
            adjustability: (getters.adjustability === null || getters.adjustability === '') && rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].einst : getters.adjustability,
            thirdRopeGuard: (getters.thirdRopeGuard === null || getters.thirdRopeGuard === '') && rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].mN_SAS : getters.thirdRopeGuard,
            configurationOverviewsManualId: state.ropeGuardArgument.configurationOverviewsManualId,
            deliverRope: (getters.deliverRope === null || getters.deliverRope === '') && rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].lseils : getters.deliverRope,
            deliverCover: (getters.tractionSheaveCover === null || getters.tractionSheaveCover === '') && rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].ltsabd : getters.tractionSheaveCover,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_thirdRopeGuard',
            data: {
                data: data,
            },
        })
            .then((response) => {
                commit('change_tnruev_storeMutation', response.data.tnruev);

                commit('change_thirdRopeGuardSelection_storeMutation', response.data.thirdRopeGuard);

                var hasDeliverSelection = (getters.selectedDeliverRope != null && getters.selectedDeliverRope.text.code != 0)
                    || (getters.selectedTractionSheaveCover != null && getters.selectedTractionSheaveCover.text.code != 0);
                var hasCurrentThirdRopeGuard = getters.selectedThirdRopeGuard != null && getters.selectedThirdRopeGuard.hasOwnProperty('text');
                var firstIndex_whichMeetConditions = -1

                if (hasDeliverSelection && state.thirdRopeGuardSelection.length > 0 && hasCurrentThirdRopeGuard) {
                    firstIndex_whichMeetConditions = state.thirdRopeGuardSelection.findIndex(i => (i.text.text == getters.selectedThirdRopeGuard.text.text));
                }

                if (firstIndex_whichMeetConditions < 0) {
                    firstIndex_whichMeetConditions = state.thirdRopeGuardSelection.findIndex(i => (i.selected == true));
                }

                if (firstIndex_whichMeetConditions < 0 && state.thirdRopeGuardSelection.length > 0) {
                    firstIndex_whichMeetConditions = 0;
                }

                dispatch('change_thirdRopeGuard_storeAction', firstIndex_whichMeetConditions > -1
                    ? state.thirdRopeGuardSelection[firstIndex_whichMeetConditions]
                    : null);
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_deliverRopeSelection_storeAction({ rootState, commit, dispatch, getters, rootGetters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            deliverRope: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].lseils : getters.deliverRope,
        }
        await axios({
            method: 'post',
            url: '/api/inputsManual/get_deliverRopeSelection',
            data: {
                data: data,
            },
        })
            .then((response) => {
                commit('change_deliverRopeSelection_storeMutation', response.data);
                var hasCurrentDeliverRope = getters.selectedDeliverRope != null && getters.selectedDeliverRope.hasOwnProperty('text');
                var firstIndex_whichMeetConditions = -1;

                if (state.deliverRopeSelection.length > 0 && hasCurrentDeliverRope) {
                    firstIndex_whichMeetConditions = state.deliverRopeSelection.findIndex(i => (i.text.code == getters.selectedDeliverRope.text.code));
                }

                if (firstIndex_whichMeetConditions < 0) {
                    firstIndex_whichMeetConditions = state.deliverRopeSelection.findIndex(i => (i.selected == true));
                }

                if (firstIndex_whichMeetConditions > -1) {
                    dispatch('change_deliverRope_storeAction', state.deliverRopeSelection[firstIndex_whichMeetConditions]);
                }
                else if (state.deliverRopeSelection.length > 0) {
                    if (hasCurrentDeliverRope) {
                        dispatch('change_deliverRope_storeAction', state.deliverRopeSelection[0]);
                    }
                    else {
                        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
                    }
                }
                else {
                    dispatch('change_deliverRope_storeAction', null);
                }
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_tractionSheaveCoverSelection_storeAction({ rootState, commit, dispatch, getters, rootGetters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            motorType: state.ropeGuardArgument.motorType,
            motorSize: state.ropeGuardArgument.motorSize,
            motorPackage: state.ropeGuardArgument.motorPackage,
            motorZusatz: state.ropeGuardArgument.motorZusatz,
            temperatureMonitoring: state.ropeGuardArgument.temperatureMonitoring,
            kidsch: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].kidsch : getters.customerIdKid,
            tractionSheaveDiameter: state.ropeGuardArgument.tractionSheaveDiameter,
            tractionSheaveWidth: state.ropeGuardArgument.tractionSheaveWidth,
            sM250_TS280: state.ropeGuardArgument.sM250_TS280,
            configurationOverviewsManualId: state.ropeGuardArgument.configurationOverviewsManualId,
            deliverCover: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].ltsabd : getters.tractionSheaveCover,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_tractionSheaveCoverSelection',
            data: {
                data: data,
            },
        })
            .then((response) => {
                commit('change_tractionSheaveCoverSelection_storeMutation', response.data);
                var selection = state.tractionSheaveCoverSelection != null
                    && state.tractionSheaveCoverSelection.hasOwnProperty('selection')
                    ? state.tractionSheaveCoverSelection.selection
                    : [];
                var hasCurrentCover = getters.selectedTractionSheaveCover != null && getters.selectedTractionSheaveCover.hasOwnProperty('text');
                var canKeepCurrentCover = hasCurrentCover
                    && selection.length > 0
                    && state.tractionSheaveCoverSelection.disabled == false;
                var firstIndex_whichMeetConditions = -1;

                if (canKeepCurrentCover) {
                    firstIndex_whichMeetConditions = selection.findIndex(i => (i.text.code == getters.selectedTractionSheaveCover.text.code));

                    var shouldForceSelectedFallback = firstIndex_whichMeetConditions > -1
                        && selection[firstIndex_whichMeetConditions].text.code != 0
                        && state.tractionSheaveCoverSelection.additionalCover == false
                        && getters.selectedDeliverRope != null
                        && getters.selectedDeliverRope.hasOwnProperty('text')
                        && getters.selectedDeliverRope.text.code != 0;

                    if (shouldForceSelectedFallback) {
                        firstIndex_whichMeetConditions = -1;
                    }
                }

                if (firstIndex_whichMeetConditions < 0) {
                    firstIndex_whichMeetConditions = selection.findIndex(i => (i.selected == true));
                }

                if (firstIndex_whichMeetConditions < 0 && selection.length > 0) {
                    firstIndex_whichMeetConditions = 0;
                }

                dispatch('change_tractionSheaveCover_storeAction', firstIndex_whichMeetConditions > -1
                    ? selection[firstIndex_whichMeetConditions]
                    : null);
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_ropeClampSelection_storeAction({ rootState, commit, dispatch, getters, rootGetters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            motorType: state.ropeGuardArgument.motorType,
            motorSize: state.ropeGuardArgument.motorSize,
            motorPackage: state.ropeGuardArgument.motorPackage,
            motorZusatz: state.ropeGuardArgument.motorZusatz,
            tractionSheaveDiameter: state.ropeGuardArgument.tractionSheaveDiameter,
            tractionSheaveWidth: state.ropeGuardArgument.tractionSheaveWidth,
            configurationOverviewsManualId: state.ropeGuardArgument.configurationOverviewsManualId,
            deliverRopeClamp: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].ltklem : getters.ropeClamp,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_ropeClampSelection',
            data: {
                data: data,
            },
        })
            .then((response) => {
                commit('change_ropeClampSelection_storeMutation', response.data);
                var hasSelectionContainer = state.ropeClampSelection != null
                    && state.ropeClampSelection.hasOwnProperty('selection');
                var selection = hasSelectionContainer ? state.ropeClampSelection.selection : [];
                var hasCurrentRopeClamp = getters.selectedRopeClamp != null && getters.selectedRopeClamp.hasOwnProperty('text');
                var canKeepCurrentRopeClamp = hasCurrentRopeClamp
                    && selection.length > 0
                    && state.ropeClampSelection.disabled == false;
                var firstIndex_whichMeetConditions = -1;

                if (canKeepCurrentRopeClamp) {
                    firstIndex_whichMeetConditions = selection.findIndex(i => (i.text.code == getters.selectedRopeClamp.text.code));
                }

                if (firstIndex_whichMeetConditions < 0) {
                    firstIndex_whichMeetConditions = selection.findIndex(i => (i.selected == true));
                }

                if (firstIndex_whichMeetConditions < 0 && selection.length > 0) {
                    firstIndex_whichMeetConditions = 0;
                }

                dispatch('change_ropeClamp_storeAction', firstIndex_whichMeetConditions > -1
                    ? selection[firstIndex_whichMeetConditions]
                    : null);
            })
            .catch(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
            .then(() => {
            })
    },
    async get_rescueReturnDeviceSelection_storeAction({ rootState, commit, dispatch, getters, rootGetters }, value) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });
        const data = {
            motorType: state.ropeGuardArgument.motorType,
            motorSize: state.ropeGuardArgument.motorSize,
            motorPackage: state.ropeGuardArgument.motorPackage,
            motorZusatz: state.ropeGuardArgument.motorZusatz,
            tractionSheaveDiameter: state.ropeGuardArgument.tractionSheaveDiameter,
            tractionSheaveWidth: state.ropeGuardArgument.tractionSheaveWidth,
            deliverRopeClamp: getters.ropeClamp != null ? getters.ropeClamp : rootGetters['inputsManual/ropeGuardSelectionZLW'].ltklem,
            configurationOverviewsManualId: state.ropeGuardArgument.configurationOverviewsManualId,
            lruev: rootGetters['inputsManual/hasMotorManualData'] == true ? rootGetters['inputsManual/ropeGuardSelectionZLW'].lruev : getters.lruev,
        }

        await axios({
            method: 'post',
            url: '/api/inputsManual/get_rescueReturnDeviceSelection',
            data: {
                data: data,
            },
        })
            .then((response) => {
                commit('change_rescueReturnDeviceSelection_storeMutation', response.data);
                var hasSelectionContainer = state.rescueReturnDeviceSelection != null
                    && state.rescueReturnDeviceSelection.hasOwnProperty('selection');
                var selection = hasSelectionContainer ? state.rescueReturnDeviceSelection.selection : [];
                var hasCurrentRescueReturnDevice = getters.selectedRescueReturnDevice != null && getters.selectedRescueReturnDevice.hasOwnProperty('text');
                var canKeepCurrentRescueReturnDevice = hasCurrentRescueReturnDevice
                    && selection.length > 0
                    && state.rescueReturnDeviceSelection.disabled == false;
                var firstIndex_whichMeetConditions = -1;

                if (canKeepCurrentRescueReturnDevice) {
                    firstIndex_whichMeetConditions = selection.findIndex(i => (i.text.code == getters.selectedRescueReturnDevice.text.code));
                }

                if (firstIndex_whichMeetConditions < 0) {
                    firstIndex_whichMeetConditions = selection.findIndex(i => (i.selected == true));
                }

                if (firstIndex_whichMeetConditions < 0 && selection.length > 0) {
                    firstIndex_whichMeetConditions = 0;
                }

                dispatch('change_rescueReturnDevice_storeAction', firstIndex_whichMeetConditions > -1
                    ? selection[firstIndex_whichMeetConditions]
                    : null);
            })
            .catch(() => {
            })
            .then(() => {
                this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
            })
    },

    async get_modalRopeGuardOptionsSelections_storeAction({ rootState, commit, dispatch, rootGetters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        if (rootGetters['inputsManual/hasMotorManualData']) {
            const mN_TS = rootGetters['inputsManual/tractionSheaveSelection_mN_TS'] != null ? rootGetters['inputsManual/tractionSheaveSelection_mN_TS'] : (rootGetters['inputsManual/motorData_mN_TS'] != null ? rootGetters['inputsManual/motorData_mN_TS'] : null);

            const data = {
                deliverRope: rootState.inputsManual.motorManualData.details.lseils,
                motorType: rootState.inputsManual.motorManualData.details.mtyp,
                motorSize: rootState.inputsManual.motorManualData.details.mbg,
                motorPackage: rootState.inputsManual.motorManualData.details.mfe,
                motorZusatz: rootState.inputsManual.motorManualData.details.mzus,
                motorVoltage: rootState.inputsManual.motorManualData.details.smU1,
                motorRatedSpeed: rootState.inputsManual.motorManualData.details.mnr,
                temperatureMonitoring: rootState.inputsManual.motorManualData.details.msart,
                tractionSheaveDiameter: rootState.inputsManual.motorManualData.details.td,
                tractionSheaveWidth: rootState.inputsManual.motorManualData.details.tb,
                kid: rootState.manualHome.kid,
                sM250_TS280: rootState.inputsManual.motorManualData.details.sM250_TS280,
                deliverCover: rootState.inputsManual.motorManualData.details.ltsabd,
                deliverRopeClamp: rootState.inputsManual.motorManualData.details.ltklem,
                lruev: rootState.inputsManual.motorManualData.details.lruev,
                motorPosition: rootState.inputsManual.motorManualData.details.fuesse,
                ropePull: rootState.inputsManual.motorManualData.details.seilab,
                adjustability: rootState.inputsManual.motorManualData.details.einst,
                thirdRopeGuard: rootState.inputsManual.motorManualData.details.mN_SAS,
                mN_TS: mN_TS,
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            }
            await axios({
                method: 'post',
                url: '/api/inputsManual/get_modalRopeGuardOptionsSelections',
                data: {
                    data: data,
                },
            })
                .then((response) => {
                    commit('change_ropeGuardDetailsSelected_storeMutation', response.data.ropeGuardDetailsSelected);

                    // deliver rope selection
                    commit('change_deliverRopeSelection_storeMutation', response.data.ropeGuard);

                    // traction sheave cover selection
                    commit('change_tractionSheaveCoverSelection_storeMutation', response.data.tractionSheaveCover);

                    // adjustability selection
                    commit('change_adjustabilitySelection_storeMutation', response.data.adjustability);

                    // third rope guard selection
                    commit('change_thirdRopeGuardSelection_storeMutation', response.data.thirdRopeGuard);

                    // rope clamp selection
                    commit('change_ropeClampSelection_storeMutation', response.data.ropeClamp);

                    // rescue return device selection
                    commit('change_rescueReturnDeviceSelection_storeMutation', response.data.rescueReturnDevice);
                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });

                })
        }
    },


    async get_altRopeGuardSelections_storeAction({ rootState, commit, dispatch, rootGetters }) {
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: true, reasonWhy_loaderModal_Shown: 'data_BeingLoaded' });

        if (rootGetters['inputsManual/hasMotorManualData']) {
            const data = {
                motorType: rootState.inputsManual.motorManualData.details.mtyp,
                motorSize: rootState.inputsManual.motorManualData.details.mbg,
                motorPackage: rootState.inputsManual.motorManualData.details.mfe,
                motorZusatz: rootState.inputsManual.motorManualData.details.mzus,
                tractionSheaveDiameter: rootState.inputsManual.motorManualData.details.td,
                tractionSheaveWidth: rootState.inputsManual.motorManualData.details.tb,
                kid: rootState.manualHome.kid,
                configurationOverviewsManualId: rootState.manualHome.configurationOverviewsManualId,
            }
            await axios({
                method: 'post',
                url: '/api/inputsManual/get_altRopeGuardSelections',
                data: {
                    data: data,
                },
            })
                .then((response) => {
                    commit('change_AltRopeGuardSelection_storeMutation', response.data.altRopeGuard);
                    commit('change_AltLseilsSelection_storeMutation', response.data.lseils);
                    commit('change_AltLtsabdSelection_storeMutation', response.data.ltsabd);
                    commit('change_AltLtklemSelection_storeMutation', response.data.ltklem);
                    commit('change_AltLruevSelection_storeMutation', response.data.lruev);
                    commit('change_AltRopeGuard_storeMutation', response.data.altRopeGuard.find(i => i.id == response.data.altRopeGuardSelectedId));
                    commit('change_altLseilsSelectedCode_storeMutation', response.data.lseilsSelectedCode);
                    commit('change_altLtsabdSelectedCode_storeMutation', response.data.ltsabdSelectedCode);
                    commit('change_altLtklemSelectedCode_storeMutation', response.data.ltklemSelectedCode);
                    commit('change_altLruevSelectedCode_storeMutation', response.data.lruevSelectedCode);

                })
                .catch(() => {
                })
                .then(() => {
                    this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });

                })
        }
    },

    change_customerIdKid_storeAction({ rootState, commit, dispatch, rootGetters }, value) {
        commit('change_customerIdKidSelected_storeMutation', value == null ? null : value.text.text);

        var hasSelectedCustomerIdKid = state.customerIdKidSelection.findIndex(i => (i.selected == true)) > -1;
        var hasMotorManualData = rootGetters['inputsManual/hasMotorManualData']

        if (hasSelectedCustomerIdKid && hasMotorManualData == false) {
            dispatch('get_deliverRopeSelection_storeAction');
            dispatch('get_tractionSheaveCoverSelection_storeAction');
            return;
        }

        if (hasSelectedCustomerIdKid == false || hasMotorManualData) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },
    change_positionMotor_storeAction({ rootState, commit, dispatch, rootGetters }, value) {
        commit('change_positionMotorSelected_storeMutation', value == null ? null : value.text.text);
        var hasSelectedPositionMotor = state.positionMotorSelection.findIndex(i => (i.selected == true)) > -1;
        var hasMotorManualData = rootGetters['inputsManual/hasMotorManualData'];
        if (hasSelectedPositionMotor && hasMotorManualData == false) {
            dispatch('get_ropePullSelection_storeAction');
            return;
        }

        if (hasSelectedPositionMotor == false || hasMotorManualData) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },
    change_ropePull_storeAction({ rootState, commit, dispatch, rootGetters }, value) {

        commit('change_ropePullSelected_storeMutation', value == null ? null : value.text.text);
        var hasSelectedRopePull = state.ropePullSelection.findIndex(i => (i.selected == true)) > -1;
        var hasMotorManualData = rootGetters['inputsManual/hasMotorManualData'];

        if (hasSelectedRopePull && hasMotorManualData == false) {
            dispatch('get_adjustabilitySelection_storeAction');
            return;
        }

        if (hasSelectedRopePull == false || hasMotorManualData) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },
    change_adjustability_storeAction({ rootState, commit, dispatch, rootGetters }, value) {
        commit('change_adjustabilitySelected_storeMutation', value == null ? null : value.text.text);
        var hasSelectedAdjustability = state.adjustabilitySelection.findIndex(i => (i.selected == true)) > -1;
        var hasMotorManualData = rootGetters['inputsManual/hasMotorManualData'];
        if (hasSelectedAdjustability && hasMotorManualData == false) {
            dispatch('get_thirdRopeGuard_storeAction');
            dispatch('get_ropeClampSelection_storeAction');
            return;
        }

        if (hasSelectedAdjustability == false || hasMotorManualData) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },
    change_thirdRopeGuard_storeAction({ rootState, commit, dispatch }, value) {
        commit('change_thirdRopeGuardSelected_storeMutation', value == null ? null : value.text.text);
    },

    async change_deliverRope_storeAction({ rootState, commit, dispatch, getters, rootGetters }, value) {
        let selectedValueChanged = (getters.deliverRope != null && value != null && getters.deliverRope == value.text.code) ? false : true;

        const selectedDeliverRope = value == null ? null : value.text.code;
        await commit('change_deliverRopeSelected_storeMutation', selectedDeliverRope);
        // if (getters.tractionSheaveCoverAdditional == true && (getters.deliverRope == null || getters.deliverRope == 0)) {
        //     await commit('change_tractionSheaveCoverSelected_storeMutation', 0);
        // }
        if (getters.tractionSheaveCoverDisabled == true && getters.selectedTractionSheaveCover != null && getters.selectedTractionSheaveCover.text.code != 0) {
            await commit('change_tractionSheaveCoverSelected_storeMutation', 0);
        }

        const hasMotorManualData = rootGetters['inputsManual/hasMotorManualData'];
        const shouldLoadPositionMotorSelection = selectedValueChanged == true
            || state.positionMotorSelection == null
            || state.positionMotorSelection.length == 0;

        if (shouldLoadPositionMotorSelection && hasMotorManualData == false) {
            await dispatch('get_positionMotorSelection_storeAction');
        }
        await dispatch('change_resetSelectionsNoRopeGuardAndNoTractionSheaveCoverSelected');

        // const hasMotorManualData = rootGetters['inputsManual/hasMotorManualData'];

        // if (hasMotorManualData == false) {
        //     dispatch('get_tractionSheaveCoverSelection_storeAction');
        //     return;
        // }

        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
    },
    async change_tractionSheaveCover_storeAction({ rootState, commit, dispatch, getters, rootGetters }, value) {
        let selectedValueChanged = (getters.tractionSheaveCover != null && value != null && getters.tractionSheaveCover == value.text.code) ? false : true;

        const selectedTractionSheaveCover = value == null ? null : value.text.code;
        await commit('change_tractionSheaveCoverSelected_storeMutation', selectedTractionSheaveCover);

        if (getters.deliverRopeSelectionDisabled == true && getters.selectedDeliverRope != null && getters.selectedDeliverRope.text.code != 0) {
            await commit('change_deliverRopeSelected_storeMutation', 0);
        }

        if (getters.tractionSheaveCoverAdditional == true &&
            getters.selectedTractionSheaveCover != null && getters.selectedTractionSheaveCover.text.code == 1  &&
            (getters.selectedDeliverRope == null || getters.selectedDeliverRope.text.code == 0)) {
            await commit('change_deliverRopeSelected_storeMutation', 1);
        }


        const hasMotorManualData = rootGetters['inputsManual/hasMotorManualData'];
        const shouldLoadPositionMotorSelection = selectedValueChanged == true
            || state.positionMotorSelection == null
            || state.positionMotorSelection.length == 0;

        if (shouldLoadPositionMotorSelection && hasMotorManualData == false) {
            await dispatch('get_positionMotorSelection_storeAction');
        }
        await dispatch('change_resetSelectionsNoRopeGuardAndNoTractionSheaveCoverSelected');

        const shouldResetLoader = shouldLoadPositionMotorSelection == false || hasMotorManualData;
        if (shouldResetLoader) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },
    change_resetSelectionsNoRopeGuardAndNoTractionSheaveCoverSelected({ rootState, commit, dispatch, getters, rootGetters }) {
        const hasNoDeliverRope = getters.deliverRope == null
            || getters.deliverRope == 0;
        const hasNoTractionSheaveCover = getters.tractionSheaveCover == null
            || getters.tractionSheaveCover == 0;
        if (hasNoDeliverRope && hasNoTractionSheaveCover) {
            commit('change_positionMotorSelection_storeMutation', []);
            commit('change_ropePullSelection_storeMutation', []);
            commit('change_thirdRopeGuardSelection_storeMutation', []);
            commit('change_adjustabilitySelection_storeMutation', []);
        }
        else {
            //commit('change_deliverRopeDisabled_storeMutation', false);
        }
    },
    change_ropeClamp_storeAction({ rootState, commit, dispatch, getters, rootGetters }, value) {
        commit('change_ropeClampSelected_storeMutation', value == null ? null : value.text.text);
        var hasSelectedRopeClamp = state.ropeClampSelection.selection.findIndex(i => (i.selected == true)) > -1;
        var hasMotorManualData = rootGetters['inputsManual/hasMotorManualData'];

        if (hasSelectedRopeClamp && hasMotorManualData == false) {
            dispatch('get_rescueReturnDeviceSelection_storeAction');
            return;
        }

        if (hasSelectedRopeClamp == false || hasMotorManualData) {
            this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
        }
    },
    change_rescueReturnDevice_storeAction({ rootState, commit, dispatch }, value) {
        commit('change_rescueReturnDeviceSelected_storeMutation', value == null ? null : value.text.text);
        this.dispatch('container/change_loaderModal_storeAction', { loaderModal_Shown: false, reasonWhy_loaderModal_Shown: null });
    },

    async change_deliverRope_configuration_storeAction({ commit, dispatch, getters }, value) {
        commit('change_deliverRopeSelected_storeMutation', value == null ? null : value.text.code);
        // if (getters.tractionSheaveCoverAdditional == true && (getters.deliverRope == null || getters.deliverRope == 0)) {
        //     commit('change_tractionSheaveCoverSelected_storeMutation', 0);
        // }
        if (getters.tractionSheaveCoverDisabled == true && getters.selectedTractionSheaveCover != null && getters.selectedTractionSheaveCover.text.code != 0) {
            await commit('change_tractionSheaveCoverSelected_storeMutation', 0);
        }

        var hasWithoutRopeGuardAndTractionSheave = ((getters.selectedDeliverRope == null || getters.selectedDeliverRope.text.text == null || getters.selectedDeliverRope.text.text == 'ohne')
            && (getters.selectedTractionSheaveCover == null || getters.selectedTractionSheaveCover.text.text == null || getters.selectedTractionSheaveCover.text.text == 'ohne'));

        if (hasWithoutRopeGuardAndTractionSheave == false) {
            commit('change_deliverRopeDisabled_storeMutation', false);
        }
        await dispatch('get_adjustabilitySelection_storeAction');
        await dispatch('get_thirdRopeGuard_storeAction');
    },
   async change_tractionSheaveCover_configuration_storeAction({ commit, dispatch, getters }, value) {
       commit('change_tractionSheaveCoverSelected_storeMutation', value == null ? null : value.text.code);

       if (getters.deliverRopeSelectionDisabled == true && getters.selectedDeliverRope != null && getters.selectedDeliverRope.text.code != 0) {
           await commit('change_deliverRopeSelected_storeMutation', 0);
       }

       if (getters.tractionSheaveCoverAdditional == true &&
           getters.selectedTractionSheaveCover != null && getters.selectedTractionSheaveCover.text.code == 1 &&
           (getters.selectedDeliverRope == null || getters.selectedDeliverRope.text.code == 0)) {
           await commit('change_deliverRopeSelected_storeMutation', 1);
       }

        var hasWithoutRopeGuardAndTractionSheave = ((getters.selectedDeliverRope == null || getters.selectedDeliverRope.text.text == null || getters.selectedDeliverRope.text.text == 'ohne')
            && (getters.selectedTractionSheaveCover == null || getters.selectedTractionSheaveCover.text.text == null || getters.selectedTractionSheaveCover.text.text == 'ohne'));

        if (hasWithoutRopeGuardAndTractionSheave == false) {
            commit('change_deliverRopeDisabled_storeMutation', false);
        }
       await dispatch('get_adjustabilitySelection_storeAction');
       await dispatch('get_thirdRopeGuard_storeAction');
    },
    change_adjustability_configuration_storeAction({ commit, dispatch }, value) {
        commit('change_adjustabilitySelected_storeMutation', value == null ? null : value.text.text);
        var hasSelectedAdjustability = state.adjustabilitySelection.findIndex(i => (i.selected == true)) > -1;
        if (hasSelectedAdjustability) {
            dispatch('get_thirdRopeGuard_storeAction');
        }
    },
    change_thirdRopeGuard_configuration_storeAction({ commit, dispatch }, value) {
        commit('change_thirdRopeGuardSelected_storeMutation', value == null ? null : value.text.text);
    },
    change_ropeClamp_configuration_storeAction({ commit, dispatch }, value) {
        commit('change_ropeClampSelected_storeMutation', value == null ? null : value.text.text);

        const selection = state.ropeClampSelection != null && state.ropeClampSelection.hasOwnProperty('selection')
            ? state.ropeClampSelection.selection
            : [];
        const hasSelectedRopeClamp = selection.some(i => i.selected == true);
        if (hasSelectedRopeClamp) {
            dispatch('get_rescueReturnDeviceSelection_storeAction');
        }
    },
    change_rescueReturnDevice_configuration_storeAction({ commit, dispatch }, value) {
        commit('change_rescueReturnDeviceSelected_storeMutation', value == null ? null : value.text.text);
    },

    set_inputManual_RopeGuard_toDefault_storeAction({ commit }) {
        commit('change_customerIdKidSelection_storeMutation', []);
        commit('change_positionMotorSelection_storeMutation', []);
        commit('change_ropePullSelection_storeMutation', []);
        commit('change_adjustabilitySelection_storeMutation', []);
        commit('change_thirdRopeGuardSelection_storeMutation', []);
        commit('change_tnruev_storeMutation', null);
        commit('change_deliverRopeSelection_storeMutation', []);
        commit('change_tractionSheaveCoverSelection_storeMutation', {});
        commit('change_ropeClampSelection_storeMutation', {});
        commit('change_deliverRopeDisabled_storeMutation', false);
        commit('change_ropeGuardDetailsSelected_storeMutation', {});
        commit('change_ropeGuardArgument_storeMutation', null);

        commit('change_AltRopeGuardSelection_storeMutation', null);
        commit('change_AltRopeGuard_storeMutation', null);
        commit('change_AltLseilsSelection_storeMutation', []);
        commit('change_AltLtsabdSelection_storeMutation', []);
        commit('change_AltLtklemSelection_storeMutation', []);
        commit('change_AltLruevSelection_storeMutation', []);
        commit('change_altLseilsSelectedCode_storeMutation', null);
        commit('change_altLtsabdSelectedCode_storeMutation', null);
        commit('change_altLtklemSelectedCode_storeMutation', null);
        commit('change_altLruevSelectedCode_storeMutation', null);
    },
    change_AltRopeGuard_storeAction({ commit }, value) {
        commit('change_altLseilsSelectedCode_storeMutation', null);
        commit('change_altLtsabdSelectedCode_storeMutation', null);
        commit('change_altLtklemSelectedCode_storeMutation', null);
        commit('change_altLruevSelectedCode_storeMutation', null);
        commit('change_AltRopeGuard_storeMutation', value);
        if (value == null) {
            return;
        }

        const hasAltLseilsSelection = state.altLseilsSelection != null && state.altLseilsSelection.length > 0;
        const hasAltLtsabdSelection = state.altLtsabdSelection != null && state.altLtsabdSelection.length > 0;

        if (value.tnschu != null && hasAltLseilsSelection) {
            commit('change_altLseilsSelectedCode_storeMutation', state.altLseilsSelection[0].text.code);
        }
        else if (value.tnsabd != null && hasAltLtsabdSelection) {
            commit('change_altLtsabdSelectedCode_storeMutation', state.altLtsabdSelection[0].text.code);
        }
    }
}

const mutations = {
    // Rope guard
    change_customerIdKidSelection_storeMutation(state, payload) {
        state.customerIdKidSelection = payload;
    },
    change_positionMotorSelection_storeMutation(state, payload) {
        state.positionMotorSelection = payload;
    },
    change_ropePullSelection_storeMutation(state, payload) {
        state.ropePullSelection = payload;
    },
    change_adjustabilitySelection_storeMutation(state, payload) {
        state.adjustabilitySelection = payload;
    },
    change_thirdRopeGuardSelection_storeMutation(state, payload) {
        state.thirdRopeGuardSelection = payload;
    },
    change_tnruev_storeMutation(state, payload) {
        state.tnruev = payload;
    },
    change_deliverRopeSelection_storeMutation(state, payload) {
        state.deliverRopeSelection = payload;
    },
    change_tractionSheaveCoverSelection_storeMutation(state, payload) {
        state.tractionSheaveCoverSelection = payload;
    },
    change_ropeClampSelection_storeMutation(state, payload) {
        state.ropeClampSelection = payload;
    },
    change_rescueReturnDeviceSelection_storeMutation(state, payload) {
        state.rescueReturnDeviceSelection = payload;
    },
    change_ropeGuardDetailsSelected_storeMutation(state, payload) {
        state.ropeGuardDetailsSelected = payload;
    },
    change_customerIdKidSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.customerIdKidSelection.length; i++) {
            state.customerIdKidSelection[i].selected = false;
            if (payload != null && payload != '' && state.customerIdKidSelection[i].text.text == payload) {
                state.customerIdKidSelection[i].selected = true;
            }
        }
    },
    change_positionMotorSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.positionMotorSelection.length; i++) {
            state.positionMotorSelection[i].selected = false;
            if (payload != null && payload != '' && state.positionMotorSelection[i].text.text == payload) {
                state.positionMotorSelection[i].selected = true;
            }
        }
    },
    change_ropePullSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.ropePullSelection.length; i++) {
            state.ropePullSelection[i].selected = false;
            if (payload != null && payload != '' && state.ropePullSelection[i].text.text == payload) {
                state.ropePullSelection[i].selected = true;
            }
        }
    },
    change_adjustabilitySelected_storeMutation(state, payload) {
        for (let i = 0; i < state.adjustabilitySelection.length; i++) {
            state.adjustabilitySelection[i].selected = false;
            if (payload != null && payload != '' && state.adjustabilitySelection[i].text.text == payload) {
                state.adjustabilitySelection[i].selected = true;
            }
        }
    },
    change_thirdRopeGuardSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.thirdRopeGuardSelection.length; i++) {
            state.thirdRopeGuardSelection[i].selected = false;
            if (payload != null && payload != '' && state.thirdRopeGuardSelection[i].text.text == payload) {
                state.thirdRopeGuardSelection[i].selected = true;
            }
        }
    },
    change_deliverRopeSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.deliverRopeSelection.length; i++) {
            state.deliverRopeSelection[i].selected = false;
            if (payload != null && payload !== '' &&
                (state.deliverRopeSelection[i].text.code == payload || state.deliverRopeSelection[i].text.text == payload)) {
                state.deliverRopeSelection[i].selected = true;
            }
        }
    },
    change_tractionSheaveCoverSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.tractionSheaveCoverSelection.selection.length; i++) {
            state.tractionSheaveCoverSelection.selection[i].selected = false;
            if (payload != null && payload !== '' &&
                (state.tractionSheaveCoverSelection.selection[i].text.code == payload || state.tractionSheaveCoverSelection.selection[i].text.text == payload)) {
                state.tractionSheaveCoverSelection.selection[i].selected = true;
            }
        }
    },
    change_ropeClampSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.ropeClampSelection.selection.length; i++) {
            state.ropeClampSelection.selection[i].selected = false;
            if (payload != null && payload != '' && state.ropeClampSelection.selection[i].text.text == payload) {
                state.ropeClampSelection.selection[i].selected = true;
            }
        }
    },
    change_rescueReturnDeviceSelected_storeMutation(state, payload) {
        for (let i = 0; i < state.rescueReturnDeviceSelection.selection.length; i++) {
            state.rescueReturnDeviceSelection.selection[i].selected = false;
            if (payload != null && payload != '' && state.rescueReturnDeviceSelection.selection[i].text.text == payload) {
                state.rescueReturnDeviceSelection.selection[i].selected = true;
            }
        }
    },

    change_deliverRopeDisabled_storeMutation(state, payload) {
        state.deliverRopeDisabled = payload;
    },
    change_showRopeGuardDetails_storeMutation(state, payload) {
        state.showRopeGuardDetails = payload;
    },
    change_ropeGuardArgument_storeMutation(state, payload) {
        state.ropeGuardArgument = payload;
    },
    change_AltRopeGuardSelection_storeMutation(state, payload) {
        state.altRopeGuardSelection = payload;
    },
    change_AltRopeGuard_storeMutation(state, payload) {
        state.altRopeGuard = payload;
    },
    change_AltLseilsSelection_storeMutation(state, payload) {
        state.altLseilsSelection = payload;
    },
    change_AltLtsabdSelection_storeMutation(state, payload) {
        state.altLtsabdSelection = payload;
    },
    change_AltLtklemSelection_storeMutation(state, payload) {
        state.altLtklemSelection = payload;
    },
    change_AltLruevSelection_storeMutation(state, payload) {
        state.altLruevSelection = payload;
    },
    change_altLseilsSelectedCode_storeMutation(state, payload) {
        state.altLseilsSelectedCode = payload;
    },
    change_altLtsabdSelectedCode_storeMutation(state, payload) {
        state.altLtsabdSelectedCode = payload;
    },
    change_altLtklemSelectedCode_storeMutation(state, payload) {
        state.altLtklemSelectedCode = payload;
    },
    change_altLruevSelectedCode_storeMutation(state, payload) {
        state.altLruevSelectedCode = payload;
    },
}

const getters = {

    tractionSheaveCoverAdditional: (state, getters, rootState, rootGetters) => {
        return state.tractionSheaveCoverSelection != null && state.tractionSheaveCoverSelection.hasOwnProperty('additionalCover')
            ? state.tractionSheaveCoverSelection.additionalCover
            : false;
    },
    tractionSheaveCoverInsteadOfRopeGuard: (state, getters, rootState, rootGetters) => {
        return state.tractionSheaveCoverSelection != null && state.tractionSheaveCoverSelection.hasOwnProperty('coverInsteadOfRopeGuard')
            ? state.tractionSheaveCoverSelection.coverInsteadOfRopeGuard
            : false;
    },
    tractionSheaveCoverDisabled: (state, getters, rootState, rootGetters) => {
        if (getters.tractionSheaveCoverAdditional === true) {
            return getters.deliverRope != null && getters.deliverRope != 0 ? false : true;
        }

        if (getters.tractionSheaveCoverInsteadOfRopeGuard === true) {
            return !(getters.deliverRope == null || getters.deliverRope == 0) ? true : false;
        }

        return true;
    },
    deliverRopeSelectionDisabled: (state, getters, rootState, rootGetters) => {
        if (state.deliverRopeSelection == null || Array.isArray(state.deliverRopeSelection) == false || state.deliverRopeSelection.length < 1) {
            return true;
        }

        if (getters.tractionSheaveCoverInsteadOfRopeGuard === true && (getters.tractionSheaveCover != null && getters.tractionSheaveCover != 0)) {
            return true;
        }

        return false;
    },
    selectedCustomerIdKid: (state, getters, rootState, rootGetters) => {
        return state.customerIdKidSelection != null && Array.isArray(state.customerIdKidSelection) ? state.customerIdKidSelection.find(i => i.selected === true) || null : null;
    },
    selectedPositionMotor: (state, getters, rootState, rootGetters) => {
        return state.positionMotorSelection != null && Array.isArray(state.positionMotorSelection) ? state.positionMotorSelection.find(i => i.selected === true) || null : null;
    },
    selectedRopePull: (state, getters, rootState, rootGetters) => {
        return state.ropePullSelection != null && Array.isArray(state.ropePullSelection) ? state.ropePullSelection.find(i => i.selected === true) || null : null;
    },
    selectedAdjustability: (state, getters, rootState, rootGetters) => {
        return state.adjustabilitySelection != null && Array.isArray(state.adjustabilitySelection) ? state.adjustabilitySelection.find(i => i.selected === true) || null : null;
    },
    selectedDeliverRope: (state, getters, rootState, rootGetters) => {
        return state.deliverRopeSelection != null && Array.isArray(state.deliverRopeSelection) ? state.deliverRopeSelection.find(i => i.selected === true) || null : null;
    },
    selectedTractionSheaveCover: (state, getters, rootState, rootGetters) => {
        return state.tractionSheaveCoverSelection != null && state.tractionSheaveCoverSelection.hasOwnProperty('selection') && Array.isArray(state.tractionSheaveCoverSelection.selection) ? state.tractionSheaveCoverSelection.selection.find(i => i.selected === true) || null : null;
    },
    selectedRopeClamp: (state, getters, rootState, rootGetters) => {
        return state.ropeClampSelection != null && state.ropeClampSelection.hasOwnProperty('selection') && Array.isArray(state.ropeClampSelection.selection) ? state.ropeClampSelection.selection.find(i => i.selected === true) || null : null;
    },
    selectedThirdRopeGuard: (state, getters, rootState, rootGetters) => {
        return state.thirdRopeGuardSelection != null && Array.isArray(state.thirdRopeGuardSelection) ? state.thirdRopeGuardSelection.find(i => i.selected === true) || null : null;
    },
    selectedRescueReturnDevice: (state, getters, rootState, rootGetters) => {
        return state.rescueReturnDeviceSelection != null && state.rescueReturnDeviceSelection.hasOwnProperty('selection') && Array.isArray(state.rescueReturnDeviceSelection.selection) ? state.rescueReturnDeviceSelection.selection.find(i => i.selected === true) || null : null;
    },


    customerIdKid: (state, getters, rootState, rootGetters) => {
        return getters.selectedCustomerIdKid != null && getters.selectedCustomerIdKid.text != null ? getters.selectedCustomerIdKid.text.text : null;
    },
    positionMotor: (state, getters, rootState, rootGetters) => {
        return getters.selectedPositionMotor != null && getters.selectedPositionMotor.text != null ? getters.selectedPositionMotor.text.text : null;
    },
    ropePull: (state, getters, rootState, rootGetters) => {
        return getters.selectedRopePull != null && getters.selectedRopePull.text != null ? getters.selectedRopePull.text.text : null;
    },
    adjustability: (state, getters, rootState, rootGetters) => {
        return getters.selectedAdjustability != null && getters.selectedAdjustability.text != null ? getters.selectedAdjustability.text.text : null;
    },
    deliverRope: (state, getters, rootState, rootGetters) => {
        return getters.selectedDeliverRope != null && getters.selectedDeliverRope.text != null ? getters.selectedDeliverRope.text.code : null;
    },
    tractionSheaveCover: (state, getters, rootState, rootGetters) => {
        return getters.selectedTractionSheaveCover != null && getters.selectedTractionSheaveCover.text != null ? getters.selectedTractionSheaveCover.text.code : null;
    },
    ropeClamp: (state, getters, rootState, rootGetters) => {
        return getters.selectedRopeClamp != null && getters.selectedRopeClamp.text != null ? getters.selectedRopeClamp.text.code : null;
    },
    lruev: (state, getters, rootState, rootGetters) => {
        return getters.selectedRescueReturnDevice != null && getters.selectedRescueReturnDevice.text != null ? getters.selectedRescueReturnDevice.text.code : null;
    },
    thirdRopeGuard: (state, getters, rootState, rootGetters) => {
        return getters.selectedThirdRopeGuard != null && getters.selectedThirdRopeGuard.text != null ? getters.selectedThirdRopeGuard.text.text : null;
    },
}

export const ropeGuardManual = {
    namespaced: true,
    components: {
        axios,
    },
    state,
    actions,
    mutations,
    getters
}